/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Weight_Unit_HintInputs */

const en_us2_profile_weight_unit_hint = /** @type {(inputs: Profile_Weight_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loads and body weight show in this unit. What you have logged stays the same; only how it is shown changes.`)
};

const pt_br2_profile_weight_unit_hint = /** @type {(inputs: Profile_Weight_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargas e peso corporal aparecem nesta unidade. O que você já registrou não muda; só a forma de mostrar.`)
};

const es_419_profile_weight_unit_hint = /** @type {(inputs: Profile_Weight_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las cargas y el peso corporal se muestran en esta unidad. Lo que registraste no cambia; solo cambia cómo se muestra.`)
};

const pt_pt2_profile_weight_unit_hint = /** @type {(inputs: Profile_Weight_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As cargas e o peso corporal aparecem nesta unidade. O que já registaste não muda; só muda a forma como é mostrado.`)
};

const fr_fr2_profile_weight_unit_hint = /** @type {(inputs: Profile_Weight_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les charges et le poids du corps s'affichent dans cette unité. Ce que tu as enregistré ne change pas ; seul l'affichage change.`)
};

const de_de2_profile_weight_unit_hint = /** @type {(inputs: Profile_Weight_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewichte und Körpergewicht erscheinen in dieser Einheit. Was du erfasst hast, bleibt gleich; nur die Anzeige ändert sich.`)
};

const it_it2_profile_weight_unit_hint = /** @type {(inputs: Profile_Weight_Unit_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carichi e peso corporeo appaiono in questa unità. Ciò che hai registrato resta uguale; cambia solo come viene mostrato.`)
};

/**
* | output |
* | --- |
* | "Loads and body weight show in this unit. What you have logged stays the same; only how it is shown changes." |
*
* @param {Profile_Weight_Unit_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_weight_unit_hint = /** @type {((inputs?: Profile_Weight_Unit_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Weight_Unit_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_weight_unit_hint(inputs)
	if (locale === "es-419") return es_419_profile_weight_unit_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_weight_unit_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_weight_unit_hint(inputs)
	if (locale === "de-DE") return de_de2_profile_weight_unit_hint(inputs)
	if (locale === "it-IT") return it_it2_profile_weight_unit_hint(inputs)
	return en_us2_profile_weight_unit_hint(inputs)
});
export { profile_weight_unit_hint as "profile.weight_unit_hint" }